/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Code',
    COUNTERPARTS: 'Counterparts',
    CURRENT: 'Current',
    GENERAL_INFORMATION: 'General information',
    MANAGER: 'Manager',
    PREVIOUS: 'Previous',
    PRODUCTS: 'Products',
    REMUNERATION: 'Remunerations',
    SUPERVISOR: 'Supervisor'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
